import {
  EnhancedFieldConfig,
  EnhancedGroupedSection,
} from '../../types/form/schema.types';

export interface GroupedApprovalSectionOptions {
  title: string;
  fields: EnhancedFieldConfig[];
}

export const createGroupedApprovalSection = ({
  title,
  fields,
}: GroupedApprovalSectionOptions): EnhancedGroupedSection => ({
  layout: 'single',
  isGrouped: true,
  isGroupedAccordion: false,
  sections: [
    {
      title: {
        text: title,
      },
      layout: 'single',
      fields,
    },
  ],
  extras: { grouped: true, evenSpacing: true },
});
